<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("ACTIVITY_DAIRY") }}</h4>
    </div>
    <div class="grid-body border-top-unset">
      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>
      <v-row class="pl-3 pr-3 pt-3">
        <v-col md="3" class="pt-0">
          <label>{{ $t("_BOOKING.SEARCH_DATE") }}</label>
          <date-range-picker
            :autoApply="true"
            :timePicker="false"
            v-model="dateRange"
            :ranges="false"
            :locale-data="locale_data"
            :appendToBody="true"
            class="w-100 text-center"
          >
            <template v-slot:input="picker" style="min-width: 450px">
              {{ _moment(picker.startDate).format("DD/MM/YYYY") }}
              <v-icon>trending_flat</v-icon>
              {{ _moment(picker.endDate).format("DD/MM/YYYY") }}
            </template>
          </date-range-picker>
        </v-col>
        <v-col md="3" class="pt-0">
          <label>{{ $t("ROOM_NAME") }}</label>
          <v-autocomplete
            item-value="value"
            item-text="text"
            :items="listSelectRoomType"
            v-model="selectedRoomType"
            outlined
            dense
          >
          </v-autocomplete>
        </v-col>
        <v-col md="3" class="pt-0">
          <label>{{ $t("_SALE_PACKAGE.SALE_PACKAGE") }}</label>
          <v-autocomplete
            item-value="value"
            item-text="text"
            :items="listSelectRoomPlan"
            v-model="selectedRoomPlan"
            outlined
            dense
          >
          </v-autocomplete>
        </v-col>
        <v-col md="3" class="pt-0">
          <label>{{ $t("SALE_CHANNEL") }}</label>
          <v-autocomplete
            item-value="value"
            item-text="text"
            :items="listSelectOTA"
            v-model="selectedOTA"
            outlined
            dense
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-0 pl-3 pr-3 mb-3">
        <v-col md="3" class="pt-0">
          <label>{{ $t("LOG_FUNCTION") }}</label>
          <v-autocomplete
            item-value="value"
            item-text="text"
            :items="listFunction"
            v-model="selectedFunction"
            outlined
            dense
          >
          </v-autocomplete>
        </v-col>
        <v-col md="3" class="pt-0">
          <label>{{ $t("LOG_ACTION") }}</label>
          <v-autocomplete
            item-value="value"
            item-text="text"
            :items="listAction"
            v-model="selectedAction"
            outlined
            dense
          >
          </v-autocomplete>
        </v-col>
        <v-col class="pt-0 d-flex align-items-end justify-content-end">
          <v-btn class="btn-update" color="primary" @click="searchLog(1)">
            {{ $t("_BOOKING.SEARCH") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th v-for="header in headers" :class="header.class">
                <div>{{ header.text }}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="dataTable.length > 0 && !isLoading">
              <tr v-for="(item, i) in dataTable">
                <td class="text-center vertical-middle">
                  {{ paging.offset + i + 1 }}
                </td>
                <td class="font-weight-bold vertical-middle">
                  {{ item.userName }}
                </td>
                <td class="vertical-middle">
                  {{
                    listAction.find((x) => x.value == item.action)
                      ? listAction.find((x) => x.value == item.action).text
                      : $t(item.action)
                  }}
                </td>
                <td class="vertical-middle">
                  {{
                    listFunction.find((x) => x.value == item.function)
                      ? listFunction.find((x) => x.value == item.function).text
                      : $t(item.function)
                  }}
                </td>
                <td class="vertical-middle">
                  <div
                    v-if="item.data.updated_i18n"
                    v-html="parseLogData(item.data.updated_i18n)"
                  ></div>
                </td>
                <td class="text-center vertical-middle">
                  {{
                    _moment(item.createdDate)
                      .add(7, "hours")
                      .format(" HH:mm:ss DD/MM/YYYY")
                  }}
                </td>
                <td class="text-center vertical-middle">
                  <v-btn
                    color="primary"
                    small
                    dark
                    @click="detailLogData(item)"
                  >
                    {{ $t("DETAIL") }}
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td
                  colspan="8"
                  class="text-center vertical-middle font-weight-bold font-italic"
                  style="color: red"
                >
                  {{ $t("NO_DATA") }}
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>

      <paging
        v-if="paging.total"
        :paging.sync="paging"
        @changePage="changePage"
        class="pl-3 pr-3"
      >
        <span slot="totalItems" v-if="paging"
          >{{ $t("TOTAL") }}: {{ $tc("ACTIVITY_LOG", paging.total) }}</span
        >
      </paging>
    </div>
    <v-dialog
      v-model="dialog"
      hide-overlay
      transition="dialog-bottom-transition"
      max-width="1000px"
    >
      <v-card class="overflow-hidden p-0">
        <v-app-bar
          absolute
          color="#fafafa"
          elevate-on-scroll
          scroll-target="#scrolling-techniques-7"
        >
          <v-toolbar-title class="label-title">{{
            $t("DETAIL")
          }}</v-toolbar-title>
        </v-app-bar>
        <v-sheet
          id="scrolling-techniques-7"
          class="overflow-y-auto fs-12 sheet-log"
          max-height="600"
        >
          <v-container class="mt-3">
            <label class="label-title">Request body: </label>
            <div class="ml-3" v-if="detailLog && detailLog.data.request_body">
              <pre>{{
                JSON.stringify(parseJison(detailLog.data.request_body), null, 2)
              }}</pre>
            </div>
            <v-divider />
            <label class="label-title">Request content type: </label>
            <div
              class="ml-3"
              v-if="detailLog && detailLog.data.request_content_type"
            >
              {{ detailLog.data.request_content_type }}
            </div>
            <v-divider />
            <label class="label-title">Request header: </label>
            <div class="ml-3" v-if="detailLog && detailLog.data.request_header">
              {{ detailLog.data.request_header }}
            </div>
            <v-divider />
            <label class="label-title">Request method: </label>
            <div class="ml-3" v-if="detailLog && detailLog.data.request_method">
              {{ detailLog.data.request_method }}
            </div>
            <v-divider />
            <label class="label-title">Request param: </label>
            <div class="ml-3" v-if="detailLog && detailLog.data.request_param">
              {{ detailLog.data.request_param }}
            </div>
            <v-divider />
            <label class="label-title">Request url: </label>
            <div class="ml-3" v-if="detailLog && detailLog.data.request_url">
              {{ detailLog.data.request_url }}
            </div>
            <v-divider />
            <label class="label-title">Response data: </label>
            <div class="ml-3" v-if="detailLog && detailLog.data.response_data">
              <pre>{{
                JSON.stringify(
                  parseJison(detailLog.data.response_data),
                  null,
                  2
                )
              }}</pre>
            </div>
            <v-divider />
            <label class="label-title">Process tracking ID: </label>
            <div class="ml-3" v-if="detailLog && detailLog.processTrackingId">
              <pre>{{ detailLog.processTrackingId }}</pre>
            </div>
          </v-container>
        </v-sheet>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Paging from "@/components/Utils/Paging.vue";
import DownloadButton from "@/components/Utils/Download.vue";
import { log } from "@/_services/Log/log.js";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import moment from "moment";

export default {
  components: {
    DateRangePicker,
    paging: Paging,
    Download: DownloadButton,
  },
  data() {
    return {
      dialog: false,
      detailLog: null,
      locale_data: {
        format: "YYYY-MM-DD",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        daysOfWeek: [
          this.$t("_DATE_RANGE.SUNDAY"),
          this.$t("_DATE_RANGE.MONDAY"),
          this.$t("_DATE_RANGE.TUESDAY"),
          this.$t("_DATE_RANGE.WEDNESDAY"),
          this.$t("_DATE_RANGE.THURSDAY"),
          this.$t("_DATE_RANGE.FRIDAY"),
          this.$t("_DATE_RANGE.SATURDAY"),
        ],
        monthNames: [
          this.$t("_DATE_RANGE.JAN"),
          this.$t("_DATE_RANGE.FEB"),
          this.$t("_DATE_RANGE.MAR"),
          this.$t("_DATE_RANGE.APR"),
          this.$t("_DATE_RANGE.MAY"),
          this.$t("_DATE_RANGE.JUN"),
          this.$t("_DATE_RANGE.JUL"),
          this.$t("_DATE_RANGE.AUG"),
          this.$t("_DATE_RANGE.SEP"),
          this.$t("_DATE_RANGE.OTC"),
          this.$t("_DATE_RANGE.NOV"),
          this.$t("_DATE_RANGE.DEC"),
        ],
        firstDay: 1,
      },
      dateRange: {},
      systemLang: this.$i18n.locale,
      isLoading: false,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center",
        },
        {
          text: this.$t("LOG_USERNAME"),
          value: "userName",
        },
        {
          text: this.$t("LOG_ACTION"),
          value: "action",
          class: "",
        },
        {
          text: this.$t("LOG_FUNCTION"),
          value: "function",
          class: "",
        },
        {
          text: this.$t("LOG_CONTENT"),
          value: "content",
          class: "text-center w-40",
        },
        {
          text: this.$t("LOG_DATE_CREATE"),
          value: "createdDate",
          class: "text-center",
        },
        {
          text: this.$t("DETAIL"),
          value: "download",
          class: "text-center",
        },
      ],
      dataTable: [],
      listSelectRoomType: [{ value: null, text: this.$t("ALL") }],
      selectedRoomType: null,
      listSelectOTA: [
        {
          text: this.$t("ALL"),
          value: null,
        },
      ],
      selectedOTA: null,
      listAction: [
        {
          text: this.$t("ALL"),
          value: null,
        },
        {
          text: this.$t("CREATE"),
          value: "CREATE",
        },
        // {
        //     text: this.$t("UPDATE"),
        //     value: "UPDATE"
        // },
        {
          text: this.$t("DELETE"),
          value: "DELETE",
        },
        {
          text: this.$t("BULK_UPDATE"),
          value: "BULK_UPDATE",
        },
        // {
        //     text: this.$t("CHANGE_STATUS"),
        //     value: "CHANGE_STATUS"
        // },
        // {
        //     text: this.$t("SETUP_OTA"),
        //     value: "SETUP_OTA"
        // },
        // {
        //     text: this.$t("AUTH"),
        //     value: "AUTH"
        // },
        // {
        //     text: this.$t("STOP_SELL_TRIGGER"),
        //     value: "STOP_SELL_TRIGGER"
        // }
      ],
      selectedAction: null,
      listFunction: [
        {
          text: this.$t("ALL"),
          value: null,
        },
        // {
        //     text: this.$t("RECEIVE_BOOKING_FROM_OTA"),
        //     value: "RECEIVE_BOOKING_FROM_OTA"
        // },
        // {
        //     text: this.$t("UPDATE_INVENTORY"),
        //     value: "UPDATE_INVENTORY"
        // },
        // {
        //     text: this.$t("RECEIVE_INVENTORY_UPDATE_FROM_PMS"),
        //     value: "RECEIVE_INVENTORY_UPDATE_FROM_PMS"
        // },
        // {
        //     text: this.$t("PUSH_BOOKING_NOTIFICATION_TO_PMS"),
        //     value: "PUSH_BOOKING_NOTIFICATION_TO_PMS"
        // },
        // {
        //     text: this.$t("HOTEL_INFO"),
        //     value: "HOTEL_INFO"
        // },
        // {
        //     text: this.$t("HOTEL_IMAGE"),
        //     value: "HOTEL_IMAGE"
        // },
        // {
        //     text: this.$t("HOTEL_AREA"),
        //     value: "HOTEL_AREA"
        // },
        // {
        //     text: this.$t("HOTEL_AMENITY"),
        //     value: "HOTEL_AMENITY"
        // },
        // {
        //     text: this.$t("HOTEL_CANCELLATION_POLICY"),
        //     value: "HOTEL_CANCELLATION_POLICY"
        // },
        // {
        //     text: this.$t("HOTEL_SETTING"),
        //     value: "HOTEL_SETTING"
        // },
        // {
        //     text: this.$t("HOTEL_PAYMENT_POLICY"),
        //     value: "HOTEL_PAYMENT_POLICY"
        // },
        // {
        //     text: this.$t("SETUP_AND_MAPPING_TO_OTA"),
        //     value: "SETUP_AND_MAPPING_TO_OTA"
        // },
        // {
        //     text: this.$t("HOTEL_RATE_PLAN"),
        //     value: "HOTEL_RATE_PLAN"
        // },
        // {
        //     text: this.$t("HOTEL_RESTRICTION"),
        //     value: "HOTEL_RESTRICTION"
        // },
        // {
        //     text: this.$t("HOTEL_ROOM_TYPE"),
        //     value: "HOTEL_ROOM_TYPE"
        // },
        // {
        //     text: this.$t("HOTEL_ROOM_TYPE_AMENITY"),
        //     value: "HOTEL_ROOM_TYPE_AMENITY"
        // },
        // {
        //     text: this.$t("HOTEL_ROOM_TYPE_AVAILABILITY"),
        //     value: "HOTEL_ROOM_TYPE_AVAILABILITY"
        // },
        // {
        //     text: this.$t("HOTEL_ROOM_RATE"),
        //     value: "HOTEL_ROOM_RATE"
        // },
        // {
        //     text: this.$t("HOTEL_ROOM_TYPE_STOP_SELL"),
        //     value: "HOTEL_ROOM_TYPE_STOP_SELL"
        // },
        // {
        //     text: this.$t("HOTEL_ROOM_RATE_ADULT"),
        //     value: "HOTEL_ROOM_RATE_ADULT"
        // },
        // {
        //     text: this.$t("HOTEL_ROOM_RATE_CHILD"),
        //     value: "HOTEL_ROOM_RATE_CHILD"
        // },
        // {
        //     text: this.$t("HOTEL_ROOM_RATE_BABY"),
        //     value: "HOTEL_ROOM_RATE_BABY"
        // },
        // {
        //     text: this.$t("HOTEL_ROOM_RATE_SPECIAL"),
        //     value: "HOTEL_ROOM_RATE_SPECIAL"
        // },
        // {
        //     text: this.$t("STAFF_INFO"),
        //     value: "STAFF_INFO"
        // },
        // {
        //     text: this.$t("STAFF_PASSWORD"),
        //     value: "STAFF_PASSWORD"
        // },
        // {
        //     text: this.$t("STAFF_AVATAR"),
        //     value: "STAFF_AVATAR"
        // },
        // {
        //     text: this.$t("STAFF_LOGIN"),
        //     value: "STAFF_LOGIN"
        // },
        // {
        //     text: this.$t("HOTEL_REGISTER"),
        //     value: "HOTEL_REGISTER"
        // },
        // {
        //     text: this.$t("HOTEL_ROOM_TYPE_IMAGES"),
        //     value: "HOTEL_ROOM_TYPE_IMAGES"
        // },
        // {
        //     text: this.$t("IMAGE_MANAGAMENT"),
        //     value: "IMAGE_MANAGAMENT"
        // },
        // {
        //     text: this.$t("HOTEL_EMAIL"),
        //     value: "HOTEL_EMAIL"
        // },
        // {
        //     text: this.$t("_PAYGATE.PAYMENT_METHOD"),
        //     value: "PAYMENT_METHOD"
        // },
        // {
        //     text: this.$t("PROMOTION"),
        //     value: "HOTEL_PROMOTION"
        // },
        // {
        //     text: this.$t("SERVICES"),
        //     value: "HOTEL_SERVICE"
        // },
        // {
        //     text: this.$t("_ACTIVITY.HOTEL_UPDATE_PAYMENT_BOOKING"),
        //     value: "HOTEL_CONFIRM_PAYMENT"
        // },
        // {
        //     text: this.$t("_BOOKING_DETAIL.CANCEL"),
        //     value: "HOTEL_CANCEL_BOOKING"
        // },
        {
          text: this.$t("HOTEL_REPORT_BOOKING"),
          value: "HOTEL_REPORT_BOOKING",
        },
        // {
        //     text: this.$t("SETUP_FORMULA"),
        //     value: "SETUP_FORMULA"
        // },
        // {
        //     text: this.$t("SETUP_FORMULA_BY_DATE_RANGE"),
        //     value: "SETUP_FORMULA_BY_DATE_RANGE"
        // },
        // {
        //     text: this.$t("DELETE_FORMULA"),
        //     value: "DELETE_FORMULA"
        // },
        // {
        //     text: this.$t("DYNAMIC_PRICING"),
        //     value: "DYNAMIC_PRICING"
        // },
        // {
        //     text: this.$t("SCHEDULE_DYNAMIC_PRICING"),
        //     value: "SCHEDULE_DYNAMIC_PRICING"
        // },
        {
          text: this.$t("CHAIN_INFO"),
          value: "CHAIN_INFO",
        },
        {
          text: this.$t("CHAIN_ROOM_TYPE"),
          value: "CHAIN_ROOM_TYPE",
        },
        {
          text: this.$t("CHAIN_RATE_PLAN"),
          value: "CHAIN_RATE_PLAN",
        },
        {
          text: this.$t("UPDATE_ROOM_RATE_PMS"),
          value: "UPDATE_ROOM_RATE_PMS",
        },
        {
          text: this.$t("UPDATE_ROOM_RATE_OTA"),
          value: "UPDATE_ROOM_RATE_OTA",
        },
        {
          text: this.$t("CHAIN_ROOM_TYPE_AMENITY"),
          value: "CHAIN_ROOM_TYPE_AMENITY",
        },
        {
          text: this.$t("CHAIN_SERVICE"),
          value: "CHAIN_SERVICE",
        },
        {
          text: this.$t("CHAIN_TRAVEL_AGENT"),
          value: "CHAIN_TRAVEL_AGENT",
        },
        {
          text: this.$t("CHAIN_ROOM_CATEGORY"),
          value: "CHAIN_ROOM_CATEGORY",
        },
        {
          text: this.$t("CHAIN_RATE_CATEGORY"),
          value: "CHAIN_RATE_CATEGORY",
        },
        // {
        //     text: this.$t("HOTEL_TRAVEL_AGENT"),
        //     value: "HOTEL_TRAVEL_AGENT"
        // },
        // {
        //     text: this.$t("PACKAGE_DEAL"),
        //     value: "PACKAGE_DEAL"
        // },
        // {
        //     text: this.$t("PACKAGE_ITEM"),
        //     value: "PACKAGE_ITEM"
        // }
      ],
      selectedFunction: null,
      listSelectRoomPlan: [
        {
          text: this.$t("ALL"),
          value: null,
        },
      ],
      selectedRoomPlan: null,
      paging: {
        total: 0,
        limit: 15,
        offset: 0,
      },
    };
  },
  watch: {
    dateRange() {
      this.paging.from = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      this.paging.to = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      // this.searchLog(1);
    },
  },
  created() {
    this.dateRange = {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().add(1, "day").format("YYYY-MM-DD"),
    };
    this.initialize();
  },
  methods: {
    parseJison(data) {
      try {
        // Parse a JSON
        return JSON.parse(data);
      } catch (e) {
        return data;
      }
    },
    detailLogData(item) {
      this.dialog = true;
      this.detailLog = item;
    },
    async initialize() {
      let body_roomtype = {
        keyword: "",
        status: null,
        limit: 1000,
        offset: 0,
        orderBy: "active",
        asc: false,
      };

      await chainService.getAllRooms(body_roomtype).then((res) => {
        if (res.responseCode == 0) {
          res.data.forEach((x) => {
            this.listSelectRoomType.push({
              value: x.roomId,
              text: x.i18ns.find((x) => x.lang == this.defaultI18n).name,
            });
          });
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
      await chainService.getAllOtaChain().then((res) => {
        if (res.responseCode === 0) {
          res.data.forEach((x) => {
            this.listSelectOTA.push({
              value: x.id,
              text: x.i18ns.find((y) => y.lang == this.defaultI18n).name,
            });
          });
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });

      let body_roomplan = {
        keyword: "",
        status: null,
        limit: 1000,
        offset: 0,
        orderBy: "active",
        asc: false,
      };
      chainService.getAllRatePlanChain(body_roomplan).then((res) => {
        if (res.responseCode === 0) {
          res.data.forEach((x) => {
            this.listSelectRoomPlan.push({
              value: x.id,
              text: x.i18ns.find((y) => y.lang == this.defaultI18n).name,
            });
          });
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });

      await this.searchLog(1);
    },
    _moment: moment,
    searchLog(value) {
      let body = {
        roomTypeId: this.selectedRoomType,
        ratePlanId: this.selectedRoomPlan,
        otaId: this.selectedOTA,
        action: this.selectedAction,
        function: this.selectedFunction,
        level: null,
      };

      body.limit = this.paging.limit;
      body.offset = value === 1 ? 0 : this.paging.offset;
      body.fromDate = this.paging.from;
      body.toDate = this.paging.to;

      chainService.getAllLogs(body).then((res) => {
        this.dataTable = res.data.map((logData) => {
          if (logData.data.updated_i18n) {
            logData.data.i18ns = logData.data.updated_i18n
              .split("EZ_CMS_SPLIT;")
              .map((i18n) => JSON.parse(i18n));
          }
          return logData;
        });
        this.paging.total = res.total;
      });
    },
    changePage(paging) {
      this.paging = paging;
      this.searchLog(this.paging.offset);
    },
    getKeyWordLog(key, value) {
      let keyString = "";
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(key)) {
        keyString = key;
      } else {
        keyString = this.$t(`HOTEL_LOG_${key}`);
      }
      return `<strong>${keyString}</strong> : ${value}`;
    },
    parseLogData(logJson) {
      try {
        if (
          typeof logJson !== "undefined" &&
          logJson !== null &&
          logJson !== ""
        ) {
          const logData = JSON.parse(logJson);
          const outPut = this.parseChildData(logData, true);

          return outPut;
        }
        return logJson;
      } catch (e) {
        return null;
      }
    },
    parseChildData(data, first = false) {
      let logStringOut = "";
      if (!first) {
        logStringOut += "<br/>";
        logStringOut += "<div class='ml-4'>";
      }
      for (const prop in data) {
        if (typeof data[prop] === "object") {
          logStringOut += this.getKeyWordLog(
            prop,
            this.parseChildData(data[prop])
          );
        } else {
          logStringOut += `${this.getKeyWordLog(prop, data[prop])}<br/>`;
        }
      }
      if (!first) {
        logStringOut += "</div>";
      }
      return logStringOut;
    },
  },
};
</script>

<style>
.download-button:hover {
  text-decoration: none;
}
</style>
